import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { SsoStatusService } from '@pages/login/services/sso-status.service';
import { LoadSsoStatus } from '@pages/login/store/actions/company-login-sso.actions';
import { SsoStatus } from '@pages/login/models/sso-status.interface';

interface CompanyLoginSsoStateModel {
  isEnabled: boolean;
  samlLoginUrl?: string;
}

@State<CompanyLoginSsoStateModel>({
  name: 'companyLoginSso',
  defaults: {
    isEnabled: false,
  },
})
@Injectable()
export class CompanyLoginSsoState {
  private readonly ssoStatusService = inject(SsoStatusService);

  @Selector()
  static isSsoEnabled(state: CompanyLoginSsoStateModel): boolean | undefined {
    return state.isEnabled;
  }

  @Selector()
  static samlLoginUrl(state: CompanyLoginSsoStateModel): string | undefined {
    return state.samlLoginUrl;
  }

  @Action(LoadSsoStatus)
  loadSsoStatus(context: StateContext<CompanyLoginSsoStateModel>, { organizationName, trackingId }: LoadSsoStatus): Observable<SsoStatus> {
    return this.ssoStatusService.getSsoStatus(organizationName, trackingId).pipe(
      tap(({ isEnabled, samlLoginUrl }) => {
        context.patchState({
          isEnabled,
          samlLoginUrl,
        });
      })
    );
  }
}
